import React, { useEffect, useState } from 'react';
import NotificationsSettings from '../NotificationsSettings';
import NotificationsSettingsFreemiumView from '../NotificationsSettings/FreemiumView';
import { useAccount } from '../../contexts/Account';
import { AccountType } from '../../services/utils/types';
import { getNotificationPermissions } from '../../services/pushNotifications';

function CompanyPreferences({
  freemiumView,
  hidePlanDetails,
  hideBillingInformation,
}) {
  const { accountDetails, asLoggedUserDetails } = useAccount();
  const [contact, setContact] = useState({});
  const [toggleTextValues] = useState({
    blockNewAdvisorsEmail: 'COMPANY-NOTIFICATIONS-NEW-ADVISORS',
    blockPushNotifications: 'ADVISOR-NOTIFICATIONS-PUSH',
  });
  const [toggleValues] = useState([
    'blockNewAdvisorsEmail',
    'blockPushNotifications',
  ]);
  const [formValues, setFormValues] = useState({});

  useEffect(() => {
    console.log(`Loading company preferences for notifications`);
    let isMounted = true;
    const currentContact = accountDetails.contacts.find(
      (cUser) => cUser.id === asLoggedUserDetails.userId
    );
    if (isMounted) {
      setContact(currentContact);
    }
    const defaultEmailObject = {};
    if (isMounted && currentContact.emailPreferences) {
      toggleValues.forEach((value) => {
        defaultEmailObject[value] =
          currentContact.emailPreferences[value] || false;
      });
    }
    const notification = getNotificationPermissions();

    console.log(`Notification permission status on load: ${notification}`);
    if (notification !== 'granted') {
      defaultEmailObject.blockPushNotifications = true;
    }
    setFormValues(defaultEmailObject);
    return () => {
      isMounted = false;
    };
  }, []);

  return !freemiumView ? (
    <NotificationsSettings
      formValues={formValues}
      setFormValues={setFormValues}
      toggleValues={toggleValues}
      toggleTextValues={toggleTextValues}
      user={contact}
      companyId={accountDetails.id}
      acountType={AccountType.COMPANY}
    />
  ) : (
    <NotificationsSettingsFreemiumView
      formValues={formValues}
      setFormValues={setFormValues}
      toggleValues={toggleValues}
      toggleTextValues={toggleTextValues}
      user={contact}
      companyId={accountDetails.id}
      acountType={AccountType.COMPANY}
      hideBillingInformation={hideBillingInformation}
      hidePlanDetails={hidePlanDetails}
    />
  );
}

export default CompanyPreferences;
